// Generated by scripts/write-black-and-white-replay-fixtures.ts.
// Do not edit manually.

import type { BlackAndWhiteReplayEventType } from "./event-adapter";

export interface BlackAndWhiteReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface BlackAndWhiteReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: BlackAndWhiteReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface BlackAndWhiteReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "black-and-white";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly observerUserId: string;
  readonly players: readonly BlackAndWhiteReplayFixturePlayer[];
  readonly events: readonly BlackAndWhiteReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const BLACK_AND_WHITE_REPLAY_FIXTURES: Record<
  string,
  BlackAndWhiteReplayFixture
> = {
  "simple-2p-live": {
    schemaVersion: 1,
    gameType: "black-and-white",
    scenario: "simple-2p-live",
    source: "generated",
    capturedAt: "2026-06-03T00:00:00.000Z",
    observerUserId: "observer",
    players: [
      {
        id: "p1",
        name: "Black",
        role: "host",
      },
      {
        id: "p2",
        name: "White",
        role: "player",
      },
    ],
    events: [
      {
        sequenceNumber: 1,
        eventType: "init",
        userId: "p1",
        payload: {
          state: {
            gameId: "black-and-white-replay-simple-2p-live",
            hostPlayerId: "p1",
            observerGodViewEnabled: true,
            status: "IN_PROGRESS",
            players: [
              {
                playerId: "p1",
                score: 0,
                remainingTiles: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                usedTiles: [],
              },
              {
                playerId: "p2",
                score: 0,
                remainingTiles: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                usedTiles: [],
              },
            ],
            completedRounds: [],
            currentRound: {
              roundNumber: 1,
              phase: "FIRST_SELECTION",
              firstPlayerId: "p1",
              secondPlayerId: "p2",
              firstSubmission: null,
            },
            winnerId: null,
            maxRounds: 9,
            targetScore: 5,
          },
        },
      },
      {
        sequenceNumber: 2,
        eventType: "SyncViewerState",
        userId: "p1",
        payload: {
          actionId: "simple-2p-live:sync-initial-view",
        },
      },
      {
        sequenceNumber: 3,
        eventType: "SubmitTile",
        userId: "p1",
        payload: {
          tile: 9,
        },
      },
      {
        sequenceNumber: 4,
        eventType: "SubmitTile",
        userId: "p2",
        payload: {
          tile: 2,
        },
      },
      {
        sequenceNumber: 5,
        eventType: "SubmitTile",
        userId: "p1",
        payload: {
          tile: 8,
        },
      },
      {
        sequenceNumber: 6,
        eventType: "SubmitTile",
        userId: "p2",
        payload: {
          tile: 3,
        },
      },
      {
        sequenceNumber: 7,
        eventType: "SubmitTile",
        userId: "p1",
        payload: {
          tile: 7,
        },
      },
      {
        sequenceNumber: 8,
        eventType: "SubmitTile",
        userId: "p2",
        payload: {
          tile: 4,
        },
      },
      {
        sequenceNumber: 9,
        eventType: "SubmitTile",
        userId: "p1",
        payload: {
          tile: 6,
        },
      },
      {
        sequenceNumber: 10,
        eventType: "SubmitTile",
        userId: "p2",
        payload: {
          tile: 5,
        },
      },
      {
        sequenceNumber: 11,
        eventType: "SubmitTile",
        userId: "p1",
        payload: {
          tile: 1,
        },
      },
      {
        sequenceNumber: 12,
        eventType: "SubmitTile",
        userId: "p2",
        payload: {
          tile: 9,
        },
      },
    ],
    notes: [
      "Black and White replay fixtures model validator-produced viewer-state snapshots rather than exposing private canonical state in the UI.",
      "Observer god-view is enabled so the review route can toggle exact tiles and hands, matching the live observer UX.",
      "The final round uses the special 1-beats-9 rule so p1 reaches the target score in five rounds.",
    ],
  },
};
